import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-434ecba8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field-radiobutton md:mr-1" }
const _hoisted_2 = { style: {"height":"40vh","overflow":"scroll"} }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-data-message" }, "データなし", -1))
const _hoisted_4 = { class: "col-12 flex justify-content-between align-items-center mt-3" }

import { ref } from "vue";
import { useStore } from "vuex";
import { AxiosResponse } from "axios";
import { get, set } from "@vueuse/core";
import { useToast } from "primevue/usetoast";
import { useConfirm } from "primevue/useconfirm";
import { CustomerHotpepperService } from "@/clinic/services";
import { notifySuccessMsg, notityErrorMsg } from "@/clinic/utils/notify-utils";
import {
  ApiHotpepperCustomerListPayload,
  ApiMergedHotpepperCustomerPayload,
  ApiHotpepperCustomerRes,
  HotpepperCustomer,
} from "@/clinic/typings";


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogMergeHotpepper',
  setup(__props, { expose }) {

const store = useStore();
const toast = useToast();
const confirm = useConfirm();
const customerId = ref();
const searchInput = ref();
const visible = ref(false);
const tableHeader = ref([
  { field: "hotpepper_booking_code", name: "カルテNo.", style: "width: 30%; flex: none" },
  { field: "customer_name", name: "名前", style: "width: 60%; flex: none" },
]);
const hotpepperCustomers = ref([]);
const selectedHotpepperCustomers = ref([]);

const showDialog = () => set(visible, true);
const hideDialog = () => set(visible, false);

const setCustomerId = (id: string) => {
  set(customerId, id);
};

const fetchHotpepperCustomer = async () => {
  const { data } = (await CustomerHotpepperService.getList(getListPayload())) as unknown as AxiosResponse<
    ApiHotpepperCustomerRes[]
  >;
  const hotpepperCustomerList = get(data);

  selectedHotpepperCustomers?.value?.forEach((product: ApiHotpepperCustomerRes) => {
    if (hotpepperCustomerList.every(element => JSON.stringify(element) !== JSON.stringify(product))) {
      hotpepperCustomerList.unshift(product);
    }
  });

  set(hotpepperCustomers, get(data));
};

const mergeHotpepper = () => {
  confirm.require({
    message: "選択した顧客を統合します。本当によろしいですか？",
    header: "注意",
    rejectLabel: "キャンセル",
    acceptLabel: "OK",
    acceptClass: "p-button-warning",
    accept: async () => {
      const params = getMergePayload();
      await CustomerHotpepperService.merge(
        params,
        () => handleSuccessMerged(),
        () => handleFailedMerged()
      );
    },
  });
};

const getMergePayload = (): ApiMergedHotpepperCustomerPayload => {
  const merged_list: HotpepperCustomer[] = selectedHotpepperCustomers.value.map((item: HotpepperCustomer) => ({
    customer_id: item.customer_id,
    booking_id: item.booking_id,
  }));

  const payload = {
    clinic_id: store.getters["authClient/selectedClinic"].id,
    customer_id: customerId.value,
    merged_list: merged_list,
  };

  return payload as unknown as ApiMergedHotpepperCustomerPayload;
};

const getListPayload = (): ApiHotpepperCustomerListPayload => {
  const payload = {
    clinic_id: store.getters["authClient/selectedClinic"].id,
    query: searchInput.value,
  };

  return payload as unknown as ApiHotpepperCustomerListPayload;
};

const handleSuccessMerged = () => {
  set(selectedHotpepperCustomers, []);
  hideDialog();
  notifySuccessMsg(toast, "成功");
};

const handleFailedMerged = () => {
  notityErrorMsg(toast, "エラー");
};

// eslint-disable-next-line no-undef
expose({
  showDialog,
  fetchHotpepperCustomer,
  setCustomerId,
});

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      visible: visible.value,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((visible).value = $event)),
      modal: "",
      header: "ホットペッパー顧客一覧",
      draggable: false,
      style: {"width":"40%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_InputText, {
            modelValue: searchInput.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
            class: "form-search-input mr-1",
            placeholder: "ホットペッパー顧客の名前を入力してください",
            onKeyup: _withKeys(fetchHotpepperCustomer, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"]),
          _createVNode(_component_Button, {
            icon: "pi pi-search",
            class: "show-search-icon text-white",
            style: {"width":"3rem"},
            onClick: fetchHotpepperCustomer
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_DataTable, {
            selection: selectedHotpepperCustomers.value,
            "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((selectedHotpepperCustomers).value = $event)),
            value: hotpepperCustomers.value,
            scrollable: ""
          }, {
            empty: _withCtx(() => [
              _hoisted_3
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                selectionMode: "multiple",
                headerStyle: "width: 10%"
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableHeader.value, (header, index) => {
                return (_openBlock(), _createBlock(_component_Column, {
                  key: index,
                  field: header.field,
                  header: header.name,
                  style: _normalizeStyle(header.style)
                }, null, 8, ["field", "header", "style"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["selection", "value"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, "選択済み: " + _toDisplayString(selectedHotpepperCustomers.value?.length), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              label: "キャンセル",
              class: "p-button-light mr-1",
              onClick: hideDialog
            }),
            _createVNode(_component_Button, {
              label: "保存",
              class: "text-white submit-button",
              onClick: mergeHotpepper,
              disabled: selectedHotpepperCustomers.value.length == 0
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Toast, { position: "top-center" })
  ], 64))
}
}

})